/* eslint-disable no-param-reassign */
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'reduxjs-toolkit-persist'
import autoMergeLevel1 from 'reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel1'
import storage from 'reduxjs-toolkit-persist/lib/storage' // defaults to localStorage for web
import auth, { logout } from '../slices/auth'
import roles from '../services/roles/roles.slice'
import users from '../services/users/users.slice'
import profile from '../slices/profile'
import centers from '../services/own-centers/centers.slice'
import companies from '../services/companies/companies.slice'

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel1,
}

const appReducer = combineReducers({
  auth,
  roles,
  users,
  profile,
  centers,
  companies,
})

const rootReducer = (state, action) => {
  if (
    action.type === logout.fulfilled.toString() ||
    action.type === logout.rejected.toString()
  ) {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

const pReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: pReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)
